/**
 * Standard Date and Time formatting utilities for AstroPredict i18n.
 * Implements Hindi quality rules:
 * - Dates use Hindi month names through Intl with Western digits (locale 'hi-IN-u-nu-latn').
 * - Times keep the same format as English.
 * - AM/PM mapped via lookup to पूर्वाह्न (AM) and अपराह्न (PM).
 */

export function formatLocalizedDate(dateStr: string | Date, locale: string): string {
  if (!dateStr) return '';
  const d = typeof dateStr === 'string' ? new Date(dateStr.includes('T') ? dateStr : `${dateStr}T12:00:00Z`) : dateStr;
  if (isNaN(d.getTime())) return String(dateStr);

  const targetLocale = locale === 'hi' ? 'hi-IN-u-nu-latn' : 'en-US';
  return new Intl.DateTimeFormat(targetLocale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(d);
}

export function formatLocalizedTime(timeStr: string, locale: string): string {
  if (!timeStr) return '';
  if (locale !== 'hi') return timeStr;

  // Replace AM / PM with पूर्वाह्न / अपराह्न
  return timeStr
    .replace(/\bAM\b/gi, 'पूर्वाह्न')
    .replace(/\bPM\b/gi, 'अपराह्न');
}
